<template>
  <a-card :bordered="false">
    <div>
      <a-table
        ref="table"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <!-- 連番 -->
        <span slot="rowIndex" slot-scope="text, record, index">
          {{ (ipagination.current - 1) * ipagination.pageSize + parseInt(index) + 1 }}
        </span>
        <!-- 操作ユーザ -->
        <div slot="realName" slot-scope="text, record">
          {{ $t( record.realname ) }}
        </div>
        <!-- 操作時間 -->
        <div slot="createTime" slot-scope="text, record">
          {{ record.createTime | dateformat('YYYY-MM-DD HH:mm:ss') }}
        </div>
        <!-- ログ内容 -->
        <span slot="logContent" slot-scope="text, record">
          <div>
            {{ getText(record) }}
          </div>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'

export default {
  name: 'LogManage',
  mixins: [tableMixin],
  data() {
    return {
      // テーブルタイトル
      columns: [
        {
          title: 'No',
          dataIndex: '',
          key: 'rowIndex',
          width: '10%',
          align: 'center',
          scopedSlots: { customRender: 'rowIndex' }
        },
        {
          title: this.$t('disp.logrealname'),
          align: 'center',
          width: '20%',
          dataIndex: 'realname',
          scopedSlots: { customRender: 'realName' }
        },
        {
          title: this.$t('disp.logcreatetime'),
          align: 'center',
          width: '20%',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: this.$t('disp.logcontent'),
          align: 'left',
          scopedSlots: { customRender: 'logContent' }
        }
      ],
      url: {
        list: '/blaze-sys/k00/k0018/LogManage/getPageList'
      }
    }
  },
  methods: {
    getText(record) {
      if (record.logContent.indexOf('|') != -1) {
        var msgs = record.logContent.split('|')
        var params = []
        for (var i = 0; i < msgs.length; i++) {
          if (i != 0) {
            params.push(this.$t(msgs[i]))
          }
        }
        return this.$t(msgs[0], params)
      } else {
        return this.$t(record.logContent)
      }
    }
  }
}
</script>
<style scoped></style>
